import { IGridComponent } from "./components/interactive-grid.component";
import type { IGridItem } from "./interactive-grid.types";

export { IGridComponent, IGridItem };
